import { render } from "./StickyScrollATable.vue?vue&type=template&id=544eb61e&scoped=true"
import script from "./StickyScrollATable.vue?vue&type=script&lang=js"
export * from "./StickyScrollATable.vue?vue&type=script&lang=js"

import "./StickyScrollATable.vue?vue&type=style&index=0&id=544eb61e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544eb61e"]])

export default __exports__